import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { Breakpoint } from '@noths/polaris-client-ribbons-base';
import { Picture } from "../../foundations/Picture/Picture";
import { PictureSource } from "../../foundations/Picture/PictureSource";
import { generateImgSrcSet } from "./utils";
import * as styles from "./ContentTiles.styles";
export var ContentTile = function ContentTile(_ref) {
  var backgroundColor = _ref.backgroundColor,
    href = _ref.href,
    imgSourcesByBreakpoint = _ref.imgSourcesByBreakpoint,
    isFourTileLayout = _ref.isFourTileLayout,
    onClick = _ref.onClick,
    title = _ref.title;
  var breakpointsInDecreasingOrder = Object.keys(imgSourcesByBreakpoint).sort(function (a, b) {
    return Breakpoint[a] - Breakpoint[b];
  });
  var smallestBreakpoint = breakpointsInDecreasingOrder[breakpointsInDecreasingOrder.length - 1];
  return /*#__PURE__*/React.createElement(_StyledA, {
    "aria-label": title,
    href: href,
    key: href,
    onClick: onClick,
    $_css: [styles.gridItem, styles.link, isFourTileLayout && styles.gridItemFourLayout]
  }, /*#__PURE__*/React.createElement(_StyledP, {
    "data-testid": "content-tile-title",
    style: {
      '--backgroundColor': backgroundColor
    },
    $_css2: styles.title
  }, /*#__PURE__*/React.createElement("span", null, title)), /*#__PURE__*/React.createElement(Picture, {
    imgCss: styles.image,
    src: imgSourcesByBreakpoint[smallestBreakpoint][0]
  }, breakpointsInDecreasingOrder.map(function (breakpoint) {
    return /*#__PURE__*/React.createElement(PictureSource, {
      key: breakpoint,
      minBreakpoint: Breakpoint[breakpoint],
      srcSet: generateImgSrcSet(imgSourcesByBreakpoint[breakpoint])
    });
  })));
};
var _StyledA = _styled("a")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledP = /*#__PURE__*/_styled2("p").withConfig({
  displayName: "ContentTile___StyledP",
  componentId: "sc-u4la43-0"
})(["", ""], function (p) {
  return p.$_css2;
});